import { CreateCreditFacility, CreditFacility } from "../types/admin-management";
import { callApiInstance } from "./api";

class CreditFacilitiesService {
  async getAllFacilities(showInactive: boolean): Promise<CreditFacility[]> {
    return (await callApiInstance({ url: `/CreditFacility?showInactive=${showInactive}` })).data;
  }
  async createFacility(data: CreateCreditFacility) {
    return (await callApiInstance({ url: "/CreditFacility", method: "POST", data })).data;
  }
  async getSingleFacility(id: number) {
    return (await callApiInstance({ url: `/CreditFacility/${id}` })).data;
  }
  async editFacility(id: number, data: CreateCreditFacility) {
    return (await callApiInstance({ url: `/CreditFacility/${id}`, method: "PUT", data })).data;
  }
  async deleteFacility(id: number) {
    return (await callApiInstance({ url: `/CreditFacility/${id}`, method: "DELETE" })).data;
  }
}
export const creditFacilitiesService = new CreditFacilitiesService();
